<template>
  <b-card-group columns>
    <b-card no-body>
      <b-card-header>
        Settings
      </b-card-header>
      <b-table-simple>
        <b-tr v-router-link="{ name:'manufacturer-detail', params: { id:$store.state.global.device.manufacturer_id }}">
          <b-td>Manufacturer</b-td>
          <b-td class="text-right">
            {{ $store.state.global.device.manufacturer_name }}
          </b-td>
        </b-tr>
        <b-tr>
          <b-td>Created</b-td>
          <b-td class="text-right">
            {{ $store.state.global.device.created | moment("YYYY-MM-DD") }}
          </b-td>
        </b-tr>
        <b-tr>
          <b-td>Updated</b-td>
          <b-td class="text-right">
            {{ $store.state.global.device.updated | moment("YYYY-MM-DD") }}
          </b-td>
        </b-tr>
      </b-table-simple>
    </b-card>
    <b-card no-body>
      <b-card-header>
        Thumbnail
      </b-card-header>
      <img
        v-if="$store.state.global.device.thumbnail"
        :src="'https://cdn.gokaizen.com/' + $store.state.global.device.thumbnail"
        alt=""
        style="max-width:300px;"
      >
      <b-card-body v-if="!$store.state.global.device.thumbnail">
        <p>No thumbnail set</p>
      </b-card-body>
    </b-card>
  </b-card-group>
</template>

<script>
export default {
  name: 'DeviceSettingsTab',

  data() {
    return {
      query: '',
    };
  },
};
</script>
